
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_14iqq_146fy_185",
  "fit-height": "awsui_fit-height_14iqq_146fy_218",
  "with-side-media": "awsui_with-side-media_14iqq_146fy_223",
  "variant-default": "awsui_variant-default_14iqq_146fy_226",
  "variant-stacked": "awsui_variant-stacked_14iqq_146fy_226",
  "refresh": "awsui_refresh_14iqq_146fy_234",
  "sticky-enabled": "awsui_sticky-enabled_14iqq_146fy_284",
  "with-stuck-sticky-header-at-bottom": "awsui_with-stuck-sticky-header-at-bottom_14iqq_146fy_290",
  "with-top-media": "awsui_with-top-media_14iqq_146fy_300",
  "content-wrapper": "awsui_content-wrapper_14iqq_146fy_305",
  "content-wrapper-fit-height": "awsui_content-wrapper-fit-height_14iqq_146fy_310",
  "media": "awsui_media_14iqq_146fy_317",
  "media-top": "awsui_media-top_14iqq_146fy_335",
  "media-side": "awsui_media-side_14iqq_146fy_340",
  "header": "awsui_header_14iqq_146fy_346",
  "header-full-page": "awsui_header-full-page_14iqq_146fy_351",
  "header-variant-embedded": "awsui_header-variant-embedded_14iqq_146fy_354",
  "header-sticky-enabled": "awsui_header-sticky-enabled_14iqq_146fy_354",
  "header-with-media": "awsui_header-with-media_14iqq_146fy_357",
  "header-sticky-disabled": "awsui_header-sticky-disabled_14iqq_146fy_363",
  "header-stuck": "awsui_header-stuck_14iqq_146fy_373",
  "header-variant-cards": "awsui_header-variant-cards_14iqq_146fy_383",
  "header-dynamic-height": "awsui_header-dynamic-height_14iqq_146fy_386",
  "with-paddings": "awsui_with-paddings_14iqq_146fy_392",
  "with-hidden-content": "awsui_with-hidden-content_14iqq_146fy_401",
  "header-variant-full-page": "awsui_header-variant-full-page_14iqq_146fy_459",
  "header-cover": "awsui_header-cover_14iqq_146fy_462",
  "content": "awsui_content_14iqq_146fy_305",
  "content-fit-height": "awsui_content-fit-height_14iqq_146fy_490",
  "content-inner": "awsui_content-inner_14iqq_146fy_496",
  "with-header": "awsui_with-header_14iqq_146fy_503",
  "footer": "awsui_footer_14iqq_146fy_507",
  "with-divider": "awsui_with-divider_14iqq_146fy_511"
};
  